@use "../../styles/breakpoint.module.scss" as *;

.tile {
    border: 1px solid var(--light-gray);
    padding: var(--spacer-16);
}

.picture {
    display: block;
    aspect-ratio: 1;

    @media ($above-mobile) {
        width: 100%;
        margin-bottom: var(--spacer-16);
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.sku {
    composes: fontEyebrow from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-8);
}

.title {
    composes: fontHeader24 from "../../styles/composable/typography.module.css";
}

.description {
    font: var(--font-p-14);
    margin-top: var(--spacer-8);
    color: var(--medium-gray);
}
